// extracted by mini-css-extract-plugin
module.exports = {"wiqb88y":"wiqb88y"};